import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
// import Image from 'react-bootstrap/Image';

import { ServMarketTop } from "../assets/ServMarketData";
import { ServMarketTopImg } from "../assets/ServMarketData";
import { ServMarketData } from "../assets/ServMarketData";
import { GoTopBtn } from '../components/GoTopBtn';
import './Services.css';

function ServMarket() {
  // console.log("get into function ServMarket()");
  return (
    <div className='services-page'>
      <header className='mt-1'>
        <Container className='d-flex align-items-center justify-content-center'>
          <h1 className='servmarket'>Service / Market</h1>
        </Container>
      </header>
      <section id='servmarkettop' className='servmarket-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 text-primary'>Market</h2>
        <Container>
          <Row className='d-flex justify-content-center'>
            { ServMarketTop.map(top => {
              return (
                <Col lg={12} key={top.id}>
                  <h2 className='m-4 fs-1 text-center text-primary'>{top.title}</h2>
                  <p className='m-2 fw-bold fs-3' style={{ whiteSpace: 'pre-wrap' }}>{top.text}</p>
                  {/* <p className='m-2 fw-bold fs-4'>{top.text}</p> */}
                </Col>
              )
            })}
          </Row>
          <Row className='d-flex justify-content-around'>
            { ServMarketTopImg.map(topimg => {
              return (
                // <Col lg={4} key={topimg.id}>
                <Col lg={4} key={topimg.id} className='d-lg-flex'>
                  <img src={topimg.image} className='img-fluid' alt={topimg.alt} />
                  {/* <Image src={topimg.image} alt={topimg.alt} /> */}
                </Col>
              );
            })}
          </Row>
          {/* <Row className='image'> <Image src={topimg.image} alt={topimg.alt} /> </Row> */}
          <br />
        </Container>
      </section>

      <section id='servmarketdat' className='servmarket-block bg-info-subtle'>
        <Container className='my-1'>
          <Row className='d-flex'> {
            ServMarketData.map(market => {
              return (
                <Col lg={12} key={market.id}>
                  <h1 className='m-4 text-center text-primary'>{market.title}</h1>
                  <h2 className='m-4 text-center text-primary'>{market.subtitle}</h2>
                  <p className='m-2 fw-bold fs-4' style={{ whiteSpace: 'pre' }}>{market.text}</p>
                  {/* <p className='m-2 fw-bold fs-4'>{market.text}</p> */}
                  <br/>
                </Col>
              )
            })
          } </Row>
        </Container>
      </section>
      <div> < GoTopBtn /> </div>
    </div>
  );
}

export default ServMarket;